import ComplaintFormContainer from './ComplaintFormContainer';
import ComplaintFormPresentation from './ComplaintFormPresentation';

export {
  ComplaintFormContainer,
  ComplaintFormPresentation
};

export default ComplaintFormContainer;